import { axios } from './get-axios';
import Axios, { AxiosRequestConfig } from "axios";
import { type BaseQueryFn } from '@reduxjs/toolkit/query/react';
import { ACCESS_TOKEN_KEY, getEnv } from '@src/core/config';

export const instance = Axios.create({
  baseURL: getEnv('REACT_APP_API_BASE_URL') + '/api/v1',
});


instance.interceptors.request.use((request: any) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (token) {
    request.headers["Authorization"] = `Bearer ${token}`;
  }
  request.headers["Content-Type"] = "application/json";
  return request;
});


export const axiosBaseQuery = (): BaseQueryFn<
  {
    url: string
    method?: AxiosRequestConfig['method']
    data?: AxiosRequestConfig['data']
    params?: AxiosRequestConfig['params']
    responseType?: AxiosRequestConfig['responseType']
  }
> => async (arg) => {
  try {
    const { url, method = 'GET', data, params, responseType } = arg;
    const axiosData = await axios({ 
      url, 
      method, 
      data, 
      params,
      responseType: responseType || 'json'
    });
    return { data: axiosData.data };
  } catch (axiosError: any) {
    return { 
      error: {
        status: axiosError?.response?.status,
        data: axiosError?.response?.data || axiosError?.message
      }
    };
  }
};





